import styled from "@emotion/styled";

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

const Th = styled.th`
 background-color: ${(props) => props.theme.bgTertiary};
 color: ${(props) => props.theme.textSecondary};
 border: 1px solid${(props) => props.theme.textPrimary};
 padding: 28px;
 font-size: 20px;
 text-align: left;
 font-weight: bold;
 @media screen and (max-width:699px){
   padding: 10px;
  }
 @media screen and (max-width:499px){
   padding: 5px;
   font-size: 10px;
  }
  &:nth-child(even) {
    background-color: ${(props) => props.theme.bgSecondary};
  }
 `;

const Td = styled.td`
  border: 1px solid ${(props) => props.theme.textPrimary};
  padding: 18px;
  @media screen and (max-width:699px){
      padding: 10px;
  }
  @media screen and (max-width:499px){
      padding: 5px;
      font-size: 10px;
  }
  `;

const Tr = styled.tr`
text-align: left;
color: ${(props) => props.theme.textPrimary};
  &:nth-child(even) {
    /* background-color: #f2f2f2; */
  }
`;

const StyledTable = () => {
  return (
    <Table >
      <thead>
        <Tr data-aos="fade-zoom-in"
          data-aos-easing="ease-in"
          data-aos-delay="400"
          data-aos-offset="0"
          data-aos-duration="500">
          <Th>2023<br />Incognito Wallet Public Alpha</Th>
          <Th>2023 Q1/Q2<br />Incognito Wallet V1.0.0</Th>
          <Th>2023 Q3<br />Incognito Wallet V1.5.0</Th>
          <Th>2023 Q4<br />Future Releases</Th>
        </Tr>
      </thead>
      <tbody data-aos="fade-zoom-in"
        data-aos-easing="ease-in"
        data-aos-delay="500"
        data-aos-offset="0"
        data-aos-duration="500">
        <Tr>
          <Td>Web Extension</Td>
          <Td>Public Security Audit</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Td>ERC-20 Support</Td>
          <Td>Avalanch C-Chain Support</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Td>BNB Chain Support </Td>
          <Td>Mainnet Support</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Td> Polygon Support</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Td>Web3 Connection</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>


      </tbody>
    </Table>
  );
};

export default StyledTable;
